import {SupportCustomerPlanModel} from '../../model/support/support-customer-plan.model';
import {SupportCustomerModel} from '../../model/support/support-customer.model';
import {SupportPlanTypeEnum} from '../../model/support/support-plan-type.enum';
import axios from '../axios';

export namespace SupportPlanController {
  export const fetchCustomerSupportPlan = async (organizationId: string) =>
    (await axios.get<SupportCustomerPlanModel>(`/internal/support/organizations/${organizationId}/plan`)).data;

  export type UpdateCustomerSupportPlanReq = {
    planType: SupportPlanTypeEnum
    monthlyHours: number
    monthlyCost: number
    version: number
  }

  export const updateCustomerSupportPlan = async (organizationId: string, planId: string, req: UpdateCustomerSupportPlanReq) =>
    (await axios.put(`/internal/support/organizations/${organizationId}/plan/${planId}`, req));

  export const fetchSupportCustomers = async () =>
    (await axios.get<SupportCustomerModel[]>(`/internal/support/customers`)).data
}